// Use environment variable or fallback to production
const RAW = process.env.REACT_APP_API_URL;

// Normalize: remove trailing slash
const NORMALIZED = RAW?.replace(/\/$/, '');

// API_URL should point to the backend base URL without /api (e.g., http://localhost:5000)
// The /api prefix will be added automatically by the api instance
export const API_URL = NORMALIZED || 'https://nammaeventzbackend-production.up.railway.app';

// API_BASE_URL is an alias for API_URL
export const API_BASE_URL = API_URL;

export default API_URL;
